import React from 'react';
export function VolumesDetail() {
  const fisicaVols = [{
    vol: '⚡ Vol. 1 — 1° Año',
    content: 'El Mundo Físico: medición, movimiento y fuerzas'
  }, {
    vol: '⚡ Vol. 2 — 2° Año',
    content: 'Energía, Trabajo y Calor'
  }, {
    vol: '⚡ Vol. 3 — 3° Año',
    content: 'Ondas, Sonido y Luz'
  }, {
    vol: '⚡ Vol. 4 — 4° Año',
    content: 'Electricidad y Magnetismo'
  }, {
    vol: '⚡ Vol. 5 — 5° Año',
    content: 'Física Moderna e Introducción Cuántica'
  }, {
    vol: '⚡ Vol. 6 — 6° Año',
    content: 'Física Aplicada: Tecnología y Sociedad'
  }];
  const quimicaVols = [{
    vol: '🧪 Vol. 1 — 1° Año',
    content: 'Materia, Mezclas y Primeras Reacciones'
  }, {
    vol: '🧪 Vol. 2 — 2° Año',
    content: 'Estructura Atómica y Tabla Periódica'
  }, {
    vol: '🧪 Vol. 3 — 3° Año',
    content: 'Enlace Químico y Propiedades'
  }, {
    vol: '🧪 Vol. 4 — 4° Año',
    content: 'Reacciones Químicas y Estequiometría'
  }, {
    vol: '🧪 Vol. 5 — 5° Año',
    content: 'Química Orgánica e Introducción Bioquímica'
  }, {
    vol: '🧪 Vol. 6 — 6° Año',
    content: 'Química Ambiental y Aplicaciones Tecnológicas'
  }];
  const includes = ['Planificación anual lista para la carpeta docente', 'Guion de clase completo (inicio–desarrollo–cierre)', 'Actividades concretas sin instrumentos caros', 'Rúbricas y evidencias de evaluación incluidas', 'Proyectos integradores por unidad', 'Efemérides argentinas integradas por grado y año'];
  const bookEmojis = ['📘', '📗', '📕', '📙', '📘', '📙'];
  const formatVolText = (volText: string) => {
    return volText.replace(/^[⚡🧪]\s*Vol\./, 'Tomo') + ':';
  };
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-262">
      <div className="max-w-5xl mx-auto" data-id="element-263">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-264">
          Lo que <span className="text-[#00FF84]" data-id="element-265">recibís</span>
        </h2>
        <div className="max-w-2xl mx-auto flex flex-col gap-8 mb-20" data-id="element-266">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-267">
            <div className="mb-6" data-id="element-268">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-[#00FF84]" data-id="element-269">
                ⚡ FÍSICA — 6 Tomos
              </h3>
              <p className="text-white/70 text-sm" data-id="element-270">
                Para docentes de Física de 1° a 6° año de secundaria
              </p>
            </div>
            <div className="space-y-5" data-id="element-271">
              {fisicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-272">
                  <span className="text-xl leading-none mt-0.5" data-id="element-273">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-274">
                    <span className="font-bold text-white mr-1" data-id="element-275">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-276">
            <div className="mb-6" data-id="element-277">
              <h3 className="text-xl md:text-2xl font-heading font-bold uppercase mb-1 text-[#00FF84]" data-id="element-278">
                🧪 QUÍMICA — 6 Tomos
              </h3>
              <p className="text-white/70 text-sm" data-id="element-279">
                Para docentes de Química de 1° a 6° año de secundaria
              </p>
            </div>
            <div className="space-y-5" data-id="element-280">
              {quimicaVols.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-281">
                  <span className="text-xl leading-none mt-0.5" data-id="element-282">
                    {bookEmojis[i]}
                  </span>
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-283">
                    <span className="font-bold text-white mr-1" data-id="element-284">
                      {formatVolText(item.vol)}
                    </span>
                    {item.content}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        <div className="max-w-2xl mx-auto bg-brand-card rounded-2xl p-8 md:p-12 border-2 border-brand-accent/40" data-id="element-285">
          <h3 className="text-2xl md:text-3xl font-heading font-bold mb-8 md:mb-10 text-center text-[#00FF84]" data-id="element-286">
            Cada tomo incluye:
          </h3>
          <div className="flex flex-col gap-5 md:gap-6" data-id="element-287">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-288">
                <div className="flex-shrink-0 w-8 h-8 bg-[#4CAF50] rounded-md flex items-center justify-center mt-0.5 text-white font-black" data-id="element-289">
                  ✓
                </div>
                <span className="font-bold text-white text-lg md:text-xl leading-snug" data-id="element-290">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}